import Marionette from 'backbone.marionette';
import Navigator from 'app';
import committeeMeetingLayoutTmpl from '../templates/committee_meeting_layout.tpl';
export default Marionette.LayoutView.extend({
  template: committeeMeetingLayoutTmpl,
  regions: {
    houseMeetingRegion: "#house-meeting-region",
    senateMeetingRegion: "#senate-meeting-region"
  },
  // events: {
  //   "click .meeting-period": "changeTimeFrame"
  // },

  changeTimeFrame: function (e) {
    e.preventDefault();
    // const timeFrame = $(e.currentTarget).attr("value")
    // Navigator.vent.trigger("meetings:" + timeFrame);

    // _.each($(".meeting-period"), function(el) {
    //   $(el).removeClass("active");
    // });
    // $(e.currentTarget).addClass("active");
  }
});